import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeSnackbar } from '../../../actions/snackbar';
import { notificationsSelector } from '../../../selectors/snackbar';
import Notification from '../Notification';

const SnackbarManager = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const notifications = useSelector(notificationsSelector);
  const [displayed, setDisplayed] = useState([]);

  const storeDisplayed = useCallback(
    id => {
      setDisplayed([...displayed, id]);
    },
    [displayed, setDisplayed]
  );

  const onNotificationExit = (_, key) => {
    // remove this snackbar from redux store
    dispatch(removeSnackbar(key));
    setDisplayed(currentDisplayed => [
      ...currentDisplayed.filter(k => key !== k)
    ]);
  };

  const updateNotifications = useCallback(() => {
    notifications.forEach(
      ({ key, id, title, message, options = {}, dismissed = false }) => {
        if (dismissed) {
          // dismiss snackbar using notistack
          closeSnackbar(key);
          return;
        }

        // do nothing if snackbar is already displayed
        if (displayed.includes(key)) return;

        // display snackbar using notistack
        enqueueSnackbar(message, {
          key,
          ...options,
          content: key => (
            <Notification
              id={id}
              type={options.variant}
              title={title}
              onCloseClick={() => closeSnackbar(key)}
            >
              {message}
            </Notification>
          ),
          onExited: onNotificationExit,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
          }
        });

        // keep track of snackbars that we've displayed
        storeDisplayed(key);
      }
    );
  }, [
    displayed,
    notifications,
    closeSnackbar,
    enqueueSnackbar,
    dispatch,
    onNotificationExit
  ]);

  useEffect(() => {
    updateNotifications();
  }, [notifications]);

  return null;
};

export default SnackbarManager;
